module.exports = __webpack_public_path__ + "static/media/S (2).7742b98a.jpg";